// @flow
import React from 'react';
import type { FormikProps } from 'formik';
import Button from 'antd/lib/button';
import styled from 'styled-components';

import { Selects, Form } from './../../../components';
import { Section, Footer } from './../../../components/layout';
import Grid, { GridItem } from './../../../components/layout/Grid';
import type { FormFieldType } from './../../../components/Form';
import CancelButton from './../../../components/CancelButton';
import type { WashingVehicleType } from '../../../lib/types/washingPriceList';
import type { VehicleGroup } from '../../../lib/types';

const SectionContent = styled.div`
  padding: 16px;
`;

const { WashingVehicleTypeSelect, BrandsSelect, VehicleTypeSelect } = Selects;

type FormProps = {
  washingVehicleType: ?WashingVehicleType,
  onSubmit: Function,
  onCancel: () => void
};

export default ({ washingVehicleType, onSubmit, onCancel }: FormProps) => {
  return (
    <Form initialValues={washingVehicleType} onSubmit={onSubmit}>
      {(FormField: FormFieldType, formikProps: FormikProps) => {
        const { handleSubmit, dirty, setFieldValue, handleBlur } = formikProps;
        return (
          <form onSubmit={handleSubmit}>
            <Section>
              <SectionContent>
                <Grid gutter="16px">
                  <GridItem>
                    <FormField
                      label="Тип ТС для моек"
                      name="washingVehicleTypeId"
                      required
                      fast
                    >
                      {({ name, value }) => (
                        <WashingVehicleTypeSelect
                          name={name}
                          value={value}
                          onChange={(value: number) =>
                            setFieldValue(name, value)
                          }
                          onBlur={() => handleBlur({ target: { name } })}
                        />
                      )}
                    </FormField>
                  </GridItem>
                  <GridItem>
                    <FormField label="Марка" name="brandId" required fast>
                      {({ name, value }) => (
                        <BrandsSelect
                          name={name}
                          value={value}
                          onChange={(value: number) =>
                            setFieldValue(name, value)
                          }
                          onBlur={() => handleBlur({ target: { name } })}
                        />
                      )}
                    </FormField>
                  </GridItem>
                  <GridItem>
                    <FormField
                      label="Группа ТС"
                      name="vehicleGroup"
                      required
                      fast
                    >
                      {({ name, value }) => (
                        <VehicleTypeSelect
                          onlyGroups
                          name={name}
                          value={value}
                          onChange={(value: VehicleGroup) =>
                            setFieldValue(name, value)
                          }
                          onBlur={() => handleBlur({ target: { name } })}
                        />
                      )}
                    </FormField>
                  </GridItem>
                </Grid>
              </SectionContent>
            </Section>
            <Footer>
              <Button type="primary" htmlType="submit" data-cy="save">
                Сохранить
              </Button>
              <CancelButton dirty={dirty} onClick={onCancel}>
                Отменить
              </CancelButton>
            </Footer>
          </form>
        );
      }}
    </Form>
  );
};
